export default __webpack_public_path__ + "app/assets/marker-icon-alt-745af827.png";